import React from 'react';
import { Container } from 'react-bootstrap';
import Navigation from '../Shared/Navigation/Navigation';

const Blogs = () => {
  return (
    <>
      <Navigation />
      <div>
        <Container>
          <h2 className="text-center pt-5">Blogs Coming Soon</h2>
        </Container>
      </div>
    </>
  );
};

export default Blogs;